import { useCallback } from 'react'
import { useSearchParams, type NavigateOptions } from 'react-router-dom'

export type SearchParamPatch = Record<string, string | null>

/**
 * `useSearchParams` plus a patcher that sets (string) or deletes (null) the
 * given keys and leaves the rest. Replaces the history entry by default — URL
 * state like the active tab shouldn't pile up back-button stops.
 */
export function useSearchParamPatch() {
  const [searchParams, setSearchParams] = useSearchParams()
  const patchSearchParams = useCallback(
    (patch: SearchParamPatch, opts?: NavigateOptions) => {
      setSearchParams(prev => {
        const next = new URLSearchParams(prev)
        for (const [key, value] of Object.entries(patch)) {
          if (value === null) next.delete(key)
          else next.set(key, value)
        }
        return next
      }, { replace: true, ...opts })
    },
    [setSearchParams],
  )
  return [searchParams, patchSearchParams] as const
}
